// removed by extract-text-webpack-plugin
module.exports = {"detailWrapper":"QUS9HHFaeQ","details":"_3rRThR7jsj","routeAccounts":"_Va-Qdx8aA"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/containers/secure/Account/AccountSummary/AccountSummary.module.less
// module id = 969
// module chunks = 3